<script setup>
import xModal from '~/components/common/xModal.vue'
import xTipsSimple from '~/components/common/xTipsSimple.vue'
import { useFutureStore } from '~/store/future'
import { accountOpen } from '@/apis/future'

const future = useFutureStore()
const show = ref(false)
const router = useRouter()
const localePath = useLocalePath()

watch(() => future.accountOpend, (nv) => {
  if (nv === false) {
    show.value = true
  }
})

async function ok() {
  const { success } = await accountOpen()
  if (success) {
    await future.queryAccountOpend()
  }
  return success
}
function close() {
  if (!future.accountOpend) {
    router.push(localePath('/'))
    future.accountOpend = null
  }
  show.value = false
}
</script>

<template>
  <xModal v-model:show="show" :title="$t('开通合约账户')" :ok="ok" @closed="close">
    <div class="text-textSecondary">
      {{ $t('重要提示') }}
    </div>
    <i18n-t class="mt-1" keypath="合约交易属于高风险交易行为，在带来更多潜在利润的同时，也蕴藏着更大风险。当市场出现剧烈波动时，您的合约帐户余额有可能全部亏损。来自{0}的用户无法使用合约交易。" scope="global" tag="div">
      <xTipsSimple :text="$t('您不是中国香港、古巴、伊朗、朝鲜、克里米亚、苏丹、叙利亚、美国[包括所有美国领土，如波多黎各、美属萨摩亚、关岛、北马里亚纳群岛邦、美属维尔京群岛（圣克罗伊岛，圣约翰岛和圣托马斯岛）]、伊拉克、孟加拉国、玻利维亚、厄瓜多尔、吉尔吉斯斯坦、塞瓦斯托波尔或网页所提供的服务受限制的任何其他管辖区的居民。如您未通过身份验证程序，将不被允许接受网页的任何服务；如认定您提供了虚假居住地址说明，TT可立即关闭您的帐户、撤单、依照现行市价结算任何未平仓的交易；如可能造成TT损失，TT将直接进行扣抵或追索。')">
        <span class="text-primary">{{ $t('部分地区') }}</span>
      </xTipsSimple>
    </i18n-t>
  </xModal>
</template>
